import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'accounts'
const verb = 'get'

export default class OspreyAccountsUnactivated extends BaseAction {
    constructor(dataKey) {
        const id = 'bdf652f0-ed8f-467f-a276-90d42bf87335'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getUnactivated(params) {
        this.params = Object.assign({
            fields: 'id,name,status,gsmId',
            status: '1,2',
            sf: 'created',
            pc: 50,
            sd: 'desc'
        }, params)

        return fetchContentIfNeeded(this)
    }
}




// WEBPACK FOOTER //
// src/actions/osprey-api/accounts/accounts-unactivated.js